import { googleLogout } from '@react-oauth/google';

export const handleLogout = () => {
  googleLogout();

  localStorage.removeItem('accessToken');

  window.location.href = '/login';
};
